import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactHero = () => {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickActions = [
    {
      icon: 'Mail',
      label: 'Send Email',
      action: () => window.location.href = 'mailto:contact.dishantpatel@gmail.com',
      color: 'text-blue-600'
    },
    {
      icon: 'Phone',
      label: 'Call Now',
      action: () => window.location.href = 'tel:+15551234567',
      color: 'text-green-600'
    },
    {
      icon: 'MessageCircle',
      label: 'Start Chat',
      action: scrollToForm,
      color: 'text-purple-600'
    },
    {
      icon: 'Calendar',
      label: 'Schedule Meeting',
      action: () => window.open('https://calendly.com/contact-dishantpatel', '_blank'),
      color: 'text-orange-600'
    }
  ];

  return (
    <div className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 rounded-2xl border border-border overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-20 h-20 border-2 border-primary rounded-full"></div>
        <div className="absolute top-32 right-16 w-16 h-16 border-2 border-accent rounded-lg rotate-45"></div>
        <div className="absolute bottom-20 left-20 w-12 h-12 border-2 border-secondary rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-24 h-24 border-2 border-primary rounded-lg rotate-12"></div>
      </div>

      <div className="relative p-8 lg:p-12">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main Heading */}
          <div className="mb-6">
            <h1 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-text-primary mb-4">
              Let's Build Something
              <span className="block text-primary">Amazing Together</span>
            </h1>
            <p className="text-lg lg:text-xl text-text-secondary max-w-2xl mx-auto leading-relaxed">
              Ready to turn your ideas into reality? I'm here to help you create exceptional 
              digital experiences that drive results and exceed expectations.
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-primary mb-1">30+</div>
              <div className="text-sm text-text-secondary">Projects Completed</div>
            </div>
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-primary mb-1">99%</div>
              <div className="text-sm text-text-secondary">Client Satisfaction</div>
            </div>
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-primary mb-1">24h</div>
              <div className="text-sm text-text-secondary">Response Time</div>
            </div>
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-primary mb-1">4.5+</div>
              <div className="text-sm text-text-secondary">Years Experience</div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            {quickActions.map((action, index) => (
              <button
                key={index}
                onClick={action.action}
                className="flex flex-col items-center p-4 bg-surface hover:bg-muted rounded-lg border border-border transition-all duration-200 hover:scale-105 hover:shadow-md group"
              >
                <div className="w-12 h-12 bg-muted group-hover:bg-background rounded-lg flex items-center justify-center mb-2 transition-colors duration-200">
                  <Icon name={action.icon} size={20} className={action.color} />
                </div>
                <span className="text-sm font-medium text-text-primary group-hover:text-primary transition-colors duration-200">
                  {action.label}
                </span>
              </button>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="default"
              size="lg"
              onClick={scrollToForm}
              iconName="MessageSquare"
              iconPosition="left"
              className="px-8"
            >
              Start a Conversation
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              onClick={() => window.open('https://calendly.com/contact-dishantpatel', '_blank')}
              iconName="Calendar"
              iconPosition="left"
              className="px-8"
            >
              Schedule a Call
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-8 pt-6 border-t border-border">
            <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-text-secondary">
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={16} color="var(--color-success)" />
                <span>Secure Communication</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={16} color="var(--color-primary)" />
                <span>Quick Response</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Award" size={16} color="var(--color-accent)" />
                <span>Quality Guaranteed</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Users" size={16} color="var(--color-secondary)" />
                <span>Client Focused</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactHero;